import type { AnyObject } from 'models/core.models';

import {
  HirePurchaseRoutePaths,
  SmallLoanRoutePaths,
} from './routes.constants';

export const TOTAL_STEPS_COUNT = 3;

export const HIRE_PURCHASE_STEPS_COUNT: AnyObject = {
  [HirePurchaseRoutePaths.LOGIN]: 1,
  [HirePurchaseRoutePaths.CONTACT]: 2,
  [HirePurchaseRoutePaths.CONTACT_EXTRA]: 2,
  [HirePurchaseRoutePaths.SIGNING]: 3,
};

export const SMALL_LOAN_STEPS_COUNT: AnyObject = {
  [SmallLoanRoutePaths.LOGIN]: 1,
  [SmallLoanRoutePaths.CONTACT]: 2,
  [SmallLoanRoutePaths.CONTACT_EXTRA]: 2,
  [SmallLoanRoutePaths.SIGNING]: 3,
};
